var render, staticRenderFns
import script from "./AxisGQL.vue?vue&type=script&lang=js&"
export * from "./AxisGQL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08a6af98')) {
      api.createRecord('08a6af98', component.options)
    } else {
      api.reload('08a6af98', component.options)
    }
    
  }
}
component.options.__file = "src/components/data-table-wrapper/data-sources/axis-gql/AxisGQL.vue"
export default component.exports